export {NotificationListComponent as NotificationList} from './NotificationListComponent';



// WEBPACK FOOTER //
// ./src/js/core-utilities/notifications/components/NotificationList/index.js